const numerReferencyjny = { t: 'Numer referencyjny', name: 'numer-referencyjny' }
export default numerReferencyjny